import { render, staticRenderFns } from "./HeartbeatsMap.vue?vue&type=template&id=70c67f4c&"
import script from "./HeartbeatsMap.vue?vue&type=script&lang=js&"
export * from "./HeartbeatsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports